export default __webpack_public_path__ + "static/media/delete.fa0787c9.svg";